<script lang="ts" setup>
import Slider from '../components/layouts/parts/Slider.vue';
import OurServices from '../components/shared/OurServices.vue';
import Partners from '../components/shared/Partners.vue';
import Innovative from '../components/shared/Innovative.vue';
import QuoteRequest from '../components/shared/QuoteRequest.vue';
import Marquee from '../components/layouts/parts/Marquee.vue';
import { ref } from 'vue';

const corp_info = ref({
  name: '',
  address: '',
  phone: '',
  mobile: '',
  email: '',
  description: '',
  logo: '',
});
corp_info.value = JSON.parse(localStorage.getItem('corp') || '{}');
</script>
<template>
  <!-- preloader -->
  <div class="preloader">
    <div class="preloader-box">
      <div class="natex-content">
        <div class="natex-circle"></div>
        <div class="natex-line-mask">
          <div class="loader-line"></div>
        </div>
        <img
          src="/assets/img/logo.png"
          alt=""
          width="80%"
          height="80%"
          style="margin: auto; display: block"
        />
      </div>
    </div>
  </div>
  <!-- preloader end -->
  <app-layout>
    <Slider />
    <OurServices />
    <!-- <Architect /> -->
    <Partners />
    <Innovative />
    <QuoteRequest />
    <!-- <OurExperts /> -->
    <Marquee />
    <!-- <Testimonial /> -->
    <!-- <News /> -->
    <!-- <Inspiration /> -->
  </app-layout>

  <a
    :href="`https://api.whatsapp.com/send?phone=${corp_info.phone}&text=السلام عليكم.`"
    class="float"
    target="_blank"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      class="bi bi-whatsapp"
      viewBox="0 0 16 16"
    >
      <path
        d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"
      />
    </svg>
  </a>
</template>

<style lang="scss" scoped>
.float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 80px;
  right: 27px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
}
.float svg {
  margin-top: 14px;
  margin-left: 16px;
}
</style>
